














































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
import moment from "moment";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import RefSvc from "@/services/ReferensiAsuhanKeperawatan";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import RencanaAskepSvc from "@/services/RencanaAskep";
import ImplementasiAskepSvc from "@/services/ImplementasiAskep";
import PerencanaanTable from "./PerencanaanTable.vue";
import PerencanaanModal from "./PerencanaanModal.vue";
import ImplementasiTable from "./ImplementasiTable.vue";
import ImplementasiModal from "./ImplementasiModal.vue";
import ImplementasiObatInline from "@/components/AskepGadar/ImplementasiObatInline.vue";
import AskepRanapInputModal from "./AskepRanapInputModal.vue";
import { bandingRencana, kelompokkan } from "@/utils/askepRencana";
import AskepCetakSvc from "@/services/AskepCetak";

@Component({
  components: {
    VCDateTimePicker,
    PerencanaanTable,
    PerencanaanModal,
    ImplementasiTable,
    ImplementasiModal,
    ImplementasiObatInline,
    AskepRanapInputModal
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class AskepRanapPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get canVerifyRencana(): boolean {
    return userModule.hasPrivilege("perencanaan-askep", "verify");
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Diagnosis", value: "diagnosis" },
    { text: "Etiologi", value: "etiologi" },
    { text: "Tanda/Gejala", value: "gejala" },
    { text: "Luaran", value: "luaran" },
    { text: "Intervensi", value: "intervensi" }
  ];

  selectProps = { openOnHover: true, offsetY: true };
  refDiag = [];
  searchDiag = null;
  searchGejala = null;
  searchGejalaInput = null;
  searchEtiologi = null;
  selectedDiag = [];
  selectedEt = {};
  refDialog = false;
  showInputModal = false;
  loadingRef = false;

  mounted() {
    this.getRefData();
    this.loadRencanaData();
    this.loadImplementasiData();
  }

  changedDiag(val) {
    console.log("change diag", val);
  }

  onInputSearchGejala(val) {
    this.searchGejala = val.map(v => v.trim()).filter(v => v.length > 0);
  }

  get user() {
    return userModule.user;
  }

  get diagList() {
    let list = this.refDiag;

    // 1. Filter berdasarkan Gejala dan Diagnosis (Multiple Keyword)
    // Keywords digunakan untuk mencari di gejala DAN diagnosis
    if (this.searchGejala && this.searchGejala.length > 0) {
      list = list.filter(dt => {
        // Cek apakah diagnosis name cocok dengan salah satu keyword
        const diagnosisMatch = this.searchGejala.some(keyword =>
          dt.name.toLowerCase().includes(keyword.toLowerCase())
        );

        // Cek apakah ada SATU gejala yang cocok dengan salah satu keyword
        const gejalaMatch = dt.gejala.some(gj => {
          const gejalaName = gj.name.toLowerCase();
          return this.searchGejala.some(keyword =>
            gejalaName.includes(keyword.toLowerCase())
          );
        });

        // Return true jika diagnosis ATAU gejala cocok
        return diagnosisMatch || gejalaMatch;
      });
    }

    // 2. Filter berdasarkan Etiologi
    // OPTIMASI: Mengganti filter().length > 0 dengan .some()
    if (this.searchEtiologi) {
      list = list.filter(dt =>
        dt.etiologi.some(et =>
          et.name.toLowerCase().includes(this.searchEtiologi.toLowerCase())
        )
      );
    }

    // sorting berdasarkan selectedDiag (diagnosa yang sudah dipilih muncul di atas)
    if (this.planningInput) {
      list = list.sort((a, b) => {
        const aSelected = this.selectedDiag.includes(a.id);
        const bSelected = this.selectedDiag.includes(b.id);
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
      });
    } else {
      // sorting berdasarkan id secara ascending jika belum ada diagnosa yang dipilih
      list = list.sort((a, b) => a.id.localeCompare(b.id));
    }

    return list;
  }

  // Extract all gejala names from refDiag for autocomplete
  // Extract all gejala and diagnosis names from refDiag for autocomplete
  get availableSearchItems(): string[] {
    const itemsSet = new Set<string>();
    this.refDiag.forEach(diag => {
      // Add diagnosis name
      itemsSet.add(diag.name);
      // Add gejala names
      diag.gejala.forEach(gj => {
        itemsSet.add(gj.name);
      });
    });
    return Array.from(itemsSet).sort();
  }

  get implementationItemList() {
    return this.implementationItems.sort(
      (a, b) =>
        new Date(b.authored_at).getTime() - new Date(a.authored_at).getTime()
    );
  }

  // Highlight keywords in text with <mark> tags
  highlightText(text: string, keywords: string[]): string {
    if (!keywords || keywords.length === 0) return text;
    let result = text;
    keywords.forEach(keyword => {
      const regex = new RegExp(`(${this.escapeRegex(keyword)})`, "gi");
      result = result.replace(regex, '<mark class="highlight-mark">$1</mark>');
    });
    return result;
  }

  // Escape special regex characters
  escapeRegex(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  // Highlight diagnosis text with searchGejala keywords
  highlightDiagnosisText(id: string, name: string): string {
    if (!this.searchGejala || this.searchGejala.length === 0) {
      return `${id} - ${name}`;
    }
    const highlightedName = this.highlightText(name, this.searchGejala);
    return `${id} - ${highlightedName}`;
  }

  // Get item type (Gejala or Diagnosis) for autocomplete items
  getItemType(item: string): string {
    // Check if item is a diagnosis name
    const isDiagnosis = this.refDiag.some(diag => diag.name === item);
    return isDiagnosis ? "Diagnosis" : "Gejala";
  }

  getRefData() {
    this.loadingRef = true;

    RefSvc.getDiagnosisCached()
      .then(resp => {
        this.refDiag = resp.data;
      })
      .finally(() => {
        this.loadingRef = false;
      });
  }

  printAskep(bagian: "perencanaan" | "implementasi" | "semua") {
    if (!this.register) return;

    AskepCetakSvc.print(this.register, bagian);
  }

  selectedDiagnosaList = [];

  isDiagnosaSelected(diagnosaId) {
    return this.selectedDiagnosaList.some(d => d.id === diagnosaId);
  }
  toggleDiagnosa(diagnosa, checked) {
    if (checked.includes(diagnosa.id)) {
      const existing = this.selectedDiagnosaList.find(
        d => d.id === diagnosa.id
      );
      if (!existing) {
        this.selectedDiagnosaList.push({
          id: diagnosa.id,
          name: diagnosa.name,
          etiologi: [],
          gejala: [],
          luaran: [],
          intervensi: []
        });
      }
    } else {
      const index = this.selectedDiagnosaList.findIndex(
        d => d.id === diagnosa.id
      );
      if (index > -1) {
        this.selectedDiagnosaList.splice(index, 1);
      }
    }
  }
  // cek etiologi
  isEtiologiSelected(diagnosaId, etiologiId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    return diagnosa ? diagnosa.etiologi.some(e => e.id === etiologiId) : false;
  }
  toggleEtiologi(diagnosaId, etiologi, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return;
    if (checked) {
      if (!diagnosa.etiologi.some(e => e.id === etiologi.id)) {
        diagnosa.etiologi.push({
          id: etiologi.id,
          name: etiologi.name,
          text: null,
          option: null
        });
      }
    } else {
      const index = diagnosa.etiologi.findIndex(e => e.id === etiologi.id);
      if (index > -1) {
        diagnosa.etiologi.splice(index, 1);
      }
    }
  }
  isLuaranSelected(diagnosaId, luaranId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    return diagnosa ? diagnosa.luaran.some(l => l.id === luaranId) : false;
  }
  toggleLuaran(diagnosaId, luaran, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return;
    if (checked) {
      if (!diagnosa.luaran.some(l => l.id === luaran.id)) {
        diagnosa.luaran.push({
          id: luaran.id,
          name: luaran.name,
          expectation: luaran.expectation,
          category: luaran.category,
          duration: null,
          duration_unit: "menit",
          hasil: []
        });

        this.$nextTick(() => {
          const refName = `durasiIntervensi${luaran.id}`;
          const durasiInput = this.$refs[refName][0] as HTMLInputElement;
          if (durasiInput) {
            durasiInput.focus();
          }
        });
      }
    } else {
      const index = diagnosa.luaran.findIndex(l => l.id === luaran.id);
      if (index > -1) {
        diagnosa.luaran.splice(index, 1);
      }
    }
  }

  isGejalaSelected(diagnosaId, gejalaId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    return diagnosa ? diagnosa.gejala.some(g => g.id === gejalaId) : false;
  }
  toggleGejala(diagnosaId, gejala, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return;
    if (checked) {
      if (!diagnosa.gejala.some(g => g.id === gejala.id)) {
        diagnosa.gejala.push({
          id: gejala.id,
          name: gejala.name,
          text: null,
          option: null
        });
      }
    } else {
      const index = diagnosa.gejala.findIndex(g => g.id === gejala.id);
      if (index > -1) {
        diagnosa.gejala.splice(index, 1);
      }
    }
  }

  isIntervensiSelected(diagnosaId, intervensiId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    return diagnosa
      ? diagnosa.intervensi.some(i => i.id === intervensiId)
      : false;
  }
  toggleIntervensi(diagnosaId, intervensi, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return;
    if (checked) {
      if (!diagnosa.intervensi.some(i => i.id === intervensi.id)) {
        diagnosa.intervensi.push({
          id: intervensi.id,
          name: intervensi.name,
          item: []
        });
      }
    } else {
      const index = diagnosa.intervensi.findIndex(i => i.id === intervensi.id);
      if (index > -1) {
        diagnosa.intervensi.splice(index, 1);
      }
    }
  }

  isIntervensiItemSelected(diagnosaId, intervensiId, itemId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return false;
    const intervensi = diagnosa.intervensi.find(i => i.id === intervensiId);
    return intervensi ? intervensi.item.some(it => it.id === itemId) : false;
  }
  toggleIntervensiItem(diagnosaId, intervensi, item, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return;
    const intervensiObj = diagnosa.intervensi.find(i => i.id === intervensi.id);
    if (!intervensiObj) return;
    if (checked) {
      if (!intervensiObj.item.some(it => it.id === item.id)) {
        intervensiObj.item.push({
          id: item.id,
          name: item.name,
          implementasi: item.implementasi,
          need_text: item.need_text,
          options: item.options || []
        });
      }
    } else {
      const index = intervensiObj.item.findIndex(it => it.id === item.id);
      if (index > -1) {
        intervensiObj.item.splice(index, 1);
      }
    }
  }

  isLuaranHasilSelected(diagnosaId, luaranId, itemId) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id === diagnosaId);
    if (!diagnosa) return false;
    const luaran = diagnosa.luaran.find(i => i.id === luaranId);
    return luaran ? luaran.hasil?.some(it => it.id === itemId) : false;
  }
  toggleLuaranHasil(diagnosaId, luaran, item, checked) {
    const diagnosa = this.selectedDiagnosaList.find(d => d.id == diagnosaId);
    if (!diagnosa) return;

    const luaranObj = diagnosa.luaran.find(i => i.id === luaran.id);
    if (!luaranObj) return;
    if (checked) {
      if (!luaranObj.hasil?.some(it => it.id === item.id)) {
        luaranObj.hasil.push({
          id: item.id,
          name: item.name
        });
      }
    } else {
      const index = luaranObj.hasil?.findIndex(it => it.id === item.id);
      if (index > -1) {
        luaranObj.hasil.splice(index, 1);
      }
    }
  }

  implementation = [];

  addImplementation() {
    const implementationData = {
      date: this.implemented_at
        ? moment(this.implemented_at).format("YYYY-MM-DD HH:mm:ss")
        : moment().format("YYYY-MM-DD HH:mm:ss"),
      implementation: [...this.implementation],
      unit: {
        id: userModule.user.unit_id,
        name: userModule.user.unit
      },
      user: {
        id: userModule.user.id,
        name: userModule.user.nama
      }
    };

    if (this.implementationInput) {
      this.updateImplementation(this.implementationIdx);
    } else {
      this.implementationItems.push(implementationData);

      // Save to backend
      this.saveImplementation(implementationData);
    }
  }

  savingImplementation = false;

  async saveImplementation(implementationData) {
    this.savingImplementation = true;

    try {
      // Clean up UI properties before sending to backend
      const cleanImplementation = implementationData.implementation.map(
        itm => ({
          ...itm,
          options: undefined,
          need_text: undefined,
          name: undefined,
          hasilLoading: undefined,
          hasilSearch: undefined,
          hasilSearchTimer: undefined,
          hasilSuggestions: undefined
        })
      );

      const resp = await ImplementasiAskepSvc.create({
        pasien_rm: this.rm,
        register_id: parseInt(this.register),
        unit_id: userModule.user.unit_id,
        user_id: userModule.user.id,
        authored_at: implementationData.date,
        content: cleanImplementation
      });

      if (resp.status == 1) {
        this.dialogImplementation = false;
        await this.loadImplementasiData();
      }
    } finally {
      this.savingImplementation = false;
    }
  }

  addToImplementation(item) {
    if (!this.implementation.some(itm => itm.id === item.id)) {
      this.implementation.push({
        // id: item.id,
        // name: item.name,
        // implementasi: item.implementasi,
        ...item,
        hasil: null,
        option_selected: null,
        text: null,
        // hasilSuggestions: [],
        hasilLoading: false,
        hasilSearch: null,
        hasilSearchTimer: null
      });
    }
  }

  removeImplementationItem(idx) {
    this.implementation.splice(idx, 1);
  }

  // client-side v-for key generator for drug entries (keeps inline state
  // stable when adding/removing drugs on one implementasi row)
  obatKeySeq = 0;

  nextObatKey() {
    this.obatKeySeq += 1;
    return this.obatKeySeq;
  }

  // RAL-033: attach/detach Pemberian Obat to an implementasi row. When set, each
  // drug is recorded to the CPO tables on save (mirror of IGD askep). One row can
  // hold multiple drugs → N cpo_item_pemberian.
  toggleObatFlag(idx) {
    const item = this.implementation[idx];
    if (!item) return;
    if (item.obat) {
      this.removeObatFlag(idx);
      return;
    }
    this.$set(this.implementation, idx, {
      ...item,
      obat: [{ _k: this.nextObatKey() }]
    });
  }

  removeObatFlag(idx) {
    const item = this.implementation[idx];
    if (!item) return;
    const next = { ...item };
    delete next.obat;
    this.$set(this.implementation, idx, next);
  }

  addObatEntry(idx) {
    const item = this.implementation[idx];
    if (!item) return;
    const obat = Array.isArray(item.obat) ? item.obat.slice() : [];
    obat.push({ _k: this.nextObatKey() });
    this.$set(this.implementation, idx, { ...item, obat });
  }

  removeObatEntry(idx, di) {
    const item = this.implementation[idx];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    obat.splice(di, 1);
    if (obat.length === 0) {
      // no drugs left — untag the whole row
      this.removeObatFlag(idx);
      return;
    }
    this.$set(this.implementation, idx, { ...item, obat });
  }

  onObatInput(idx, di, obatPayload) {
    const item = this.implementation[idx];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    const prevK = obat[di] && obat[di]._k;
    obat[di] = {
      ...obatPayload,
      _k: prevK != null ? prevK : this.nextObatKey()
    };
    this.$set(this.implementation, idx, { ...item, obat });
  }

  onHasilSearchInput(idx: number, search: string) {
    const item = this.implementation[idx];
    if (!item) return;

    item.hasilSearch = search;

    // Clear previous debounce timer
    if (item.hasilSearchTimer) {
      clearTimeout(item.hasilSearchTimer);
    }

    // Only search when keyword is at least 3 characters
    if (!search || search.length < 3) {
      item.hasilSuggestions = [];
      return;
    }

    // Skip search if the input matches the current selected value
    if (item.hasil === search) {
      return;
    }

    // Skip search if the input is already in the existing suggestions
    if (item.hasilSuggestions && item.hasilSuggestions.includes(search)) {
      return;
    }

    // Debounce: wait 300ms before making the API call
    item.hasilSearchTimer = setTimeout(async () => {
      item.hasilLoading = true;

      try {
        const response = await ImplementasiAskepSvc.searchHasilImplementasi(
          search
        );
        // Extract data field from each item in the response
        item.hasilSuggestions =
          response.data?.map((item: any) => item.data) || [];
      } catch (error) {
        console.error("Error searching hasil implementasi:", error);
        item.hasilSuggestions = [];
      } finally {
        item.hasilLoading = false;
      }
    }, 300);
  }

  planning = [];
  loadingPlanning = false;
  stoppingItem = null;
  deletingItem = null;
  verifyingItem = null;

  get planningList() {
    return this.planning.slice().sort(bandingRencana);
  }

  get bisaSalin(): boolean {
    return !this.readOnly && !this.loadingRef;
  }

  addPlanning() {
    // Get the highest seq among active items
    const activeItems = this.planning.filter(p => !p.stopped_at);
    const maxSeq =
      activeItems.length > 0
        ? Math.max(...activeItems.map(p => p.seq || 0))
        : 0;

    const planningData = {
      user: {
        id: userModule.user.id,
        name: userModule.user.nama
      },
      date: moment().format("YYYY-MM-DD HH:mm:ss"),
      unit: {
        id: userModule.user.unit_id,
        name: userModule.user.unit
      },
      diag: this.selectedDiagnosaList,
      seq: maxSeq + 1
    };

    if (this.planningInput) {
      this.updatePlanning(this.planningInput);
    } else {
      this.savePlanning(planningData);
    }
  }

  savingPlanning = false;

  async savePlanning(planningData) {
    if (this.savingPlanning) return;

    if (this.copySource) {
      const lanjut = confirm(
        "Perencanaan ini hasil salinan dari " +
          this.copySource.label +
          ". Pastikan isinya sudah diperiksa dan sesuai kondisi pasien saat ini. Simpan?"
      );

      if (!lanjut) return;
    }

    this.savingPlanning = true;

    try {
      await RencanaAskepSvc.create({
        pasien_rm: this.rm,
        register_id: parseInt(this.register),
        unit_id: userModule.scopedUnitId,
        authored_at: planningData.date,
        content: planningData.diag,
        seq: planningData.seq,
        mode: 1,
        salin_dari_id: this.copySource ? this.copySource.id : null
      });

      this.refDialog = false;

      // Reload data after save
      await this.loadRencanaData();
    } finally {
      this.savingPlanning = false;
    }
  }

  copySource: { id: number; label: string } | null = null;

  klonKonten(item) {
    return JSON.parse(JSON.stringify(item.content || []));
  }

  editPlanning(item) {
    // Prevent editing stopped items
    if (item.stopped_at) {
      return;
    }

    this.copySource = null;

    if (this.dibuatModeDua(item)) {
      this.planningInputMode2 = item;
      this.showInputModal = true;
      return;
    }

    this.planningInput = item;
    this.selectedDiag = item.content.map(it => it.id);
    this.selectedDiagnosaList = this.klonKonten(item);
    this.refDialog = true;
  }

  dibuatModeDua(item): boolean {
    return (
      Number(item.mode) === 2 &&
      Array.isArray(item.content) &&
      item.content.length === 1
    );
  }

  salinPlanning(item) {
    if (!item || !item.id) return;

    if (this.dibuatModeDua(item)) {
      this.salinItemMode2 = item;
      this.showInputModal = true;
      return;
    }

    const unitSumber = item.unit ? item.unit.nama : item.unit_id;

    this.planningInput = null;
    this.copySource = {
      id: item.id,
      label: `${unitSumber} · ${this.formatWaktuSalinan(item.authored_at)}`
    };
    this.selectedDiag = (item.content || []).map(it => it.id);
    this.selectedDiagnosaList = this.klonKonten(item);
    this.refDialog = true;
  }

  openRefDialog() {
    this.planningInput = null;
    this.copySource = null;
    this.refDialog = true;
  }

  openInputModal() {
    this.planningInputMode2 = null;
    this.salinItemMode2 = null;
    this.showInputModal = true;
  }

  formatWaktuSalinan(nilai) {
    return nilai ? moment(nilai).format("DD-MM-YYYY HH:mm") : "-";
  }

  async updatePlanning(plan) {
    // Update to backend
    if (plan.id && !this.savingPlanning) {
      this.savingPlanning = true;

      try {
        await RencanaAskepSvc.update(plan.id, {
          pasien_rm: this.rm,
          register_id: parseInt(this.register),
          authored_at: plan.authored_at,
          content: this.selectedDiagnosaList,
          mode: 1
        });

        this.refDialog = false;

        // Reload data after update
        await this.loadRencanaData();
      } finally {
        this.savingPlanning = false;
      }
    }

    this.refDialog = false;
  }

  async loadRencanaData() {
    if (!this.register) return;

    this.loadingPlanning = true;

    try {
      const response = await RencanaAskepSvc.getByRegister(this.register);
      this.planning = response.data || [];
    } catch (error) {
      console.error("Error loading rencana askep:", error);
    } finally {
      this.loadingPlanning = false;
    }
  }

  async deletePlanning(row) {
    const confirmed = await confirmRemove(
      "Hapus Perencanaan",
      "Apakah Anda yakin ingin menghapus perencanaan ini?"
    );

    if (confirmed) {
      this.deletingItem = row.id || null;
      try {
        if (row.id) {
          await RencanaAskepSvc.destroy(row.id, "");
        }

        // Reload data to ensure sync
        await this.loadRencanaData();
      } catch (error) {
        console.error("Error deleting rencana askep:", error);
      } finally {
        this.deletingItem = null;
      }
    }
  }

  // seq untuk rencana baru dari modal Askep 2 = seq aktif tertinggi + 1
  get nextSeq() {
    const activeItems = this.planning.filter(p => !p.stopped_at);
    const maxSeq =
      activeItems.length > 0
        ? Math.max(...activeItems.map(p => p.seq || 0))
        : 0;
    return maxSeq + 1;
  }

  async onSaved() {
    await this.loadRencanaData();
    await this.loadImplementasiData();
  }

  async loadImplementasiData() {
    if (!this.register) return;

    this.loadingImplementation = true;

    try {
      const response = await ImplementasiAskepSvc.getByRegister(this.register);
      this.implementationItems = response.data || [];
    } finally {
      this.loadingImplementation = false;
    }
  }

  async deleteImplementation(item, idx) {
    const confirmed = await confirmRemove(
      "Hapus Implementasi",
      "Apakah Anda yakin ingin menghapus implementasi ini?"
    );

    if (confirmed) {
      this.deletingItem = item.id || idx;
      try {
        // Delete from backend
        if (item.id) {
          await ImplementasiAskepSvc.destroy(item.id, "");
        }

        // Reload data to ensure sync
        await this.loadImplementasiData();
      } catch (error) {
        console.error("Error deleting implementasi askep:", error);
      } finally {
        this.deletingItem = null;
      }
    }
  }

  @Watch("refDialog")
  onRefDialogChanged(val: boolean) {
    if (!val) {
      // reset selection when dialog is closed
      this.selectedDiag = [];
      this.selectedDiagnosaList = [];
      this.searchDiag = null;
      this.searchGejala = null;
      this.searchEtiologi = null;
      this.planningInput = null;
      this.copySource = null;
    }
  }

  @Watch("showInputModal")
  onInputModalChanged(val: boolean) {
    if (!val) {
      this.planningInputMode2 = null;
      this.salinItemMode2 = null;
    }
  }

  @Watch("dialogImplementation")
  onDialogImplementationChanged(val: boolean) {
    if (!val) {
      // reset selection when dialog is closed
      this.implementation = [];
      this.implementationInput = null;
      this.implementationIdx = null;
      this.implemented_at = null;
    }
  }

  planningInput = null;
  planningInputMode2 = null;
  salinItemMode2 = null;

  implemented_at = null;

  implementationItems = [];
  loadingImplementation = false;
  dialogImplementation = false;
  implementationInput = null;
  implementationIdx = null;

  dialogPerencanaanPreview = false;
  dialogImplementasiPreview = false;

  // Move planning item up
  async movePlanningUp(grup: any) {
    await this.tukarUrutanGrup(grup, -1);
  }

  // Move planning item down
  async movePlanningDown(grup: any) {
    await this.tukarUrutanGrup(grup, 1);
  }

  async tukarUrutanGrup(grup: any, arah: number) {
    const daftar = kelompokkan(this.planningList);
    const posisi = daftar.findIndex(g => g.nomor === grup.nomor);
    const tujuan = posisi + arah;

    if (posisi < 0 || tujuan < 0 || tujuan >= daftar.length) return;

    const seqIni = this.seqGrup(daftar[posisi]);
    const seqTujuan = this.seqGrup(daftar[tujuan]);

    if (seqIni === null || seqTujuan === null) return;

    for (const b of daftar[posisi].baris) {
      await this.updatePlanningSeq(b, seqTujuan);
    }

    for (const b of daftar[tujuan].baris) {
      await this.updatePlanningSeq(b, seqIni);
    }

    // Reload to ensure proper sorting
    await this.loadRencanaData();
  }

  seqGrup(grup: any): number | null {
    const aktif = grup.baris.filter(b => !b.stopped_at && b.seq !== null);

    if (!aktif.length) return null;

    return Math.min(...aktif.map(b => b.seq));
  }

  // Update planning sequence number
  async updatePlanningSeq(item: any, seq: number) {
    if (!item.id || item.stopped_at) return;

    await RencanaAskepSvc.update(item.id, {
      pasien_rm: this.rm,
      register_id: parseInt(this.register),
      authored_at: item.authored_at,
      content: item.content,
      seq: seq
    });
  }

  // Stop planning item
  async stopPlanning(row: any) {
    const confirmed = await confirmRemove(
      "Stop Perencanaan",
      "Apakah Anda yakin ingin menghentikan perencanaan ini?"
    );

    if (confirmed) {
      this.stoppingItem = row.id || null;
      try {
        if (row.id) {
          await RencanaAskepSvc.update(row.id, {
            pasien_rm: this.rm,
            register_id: parseInt(this.register),
            authored_at: row.authored_at,
            content: row.content,
            seq: null,
            stopped_at: moment().format("YYYY-MM-DD HH:mm:ss")
          });
        }

        // Reload data to ensure sync
        await this.loadRencanaData();
      } catch (error) {
        console.error("Error stopping rencana askep:", error);
      } finally {
        this.stoppingItem = null;
      }
    }
  }

  // Resume planning item
  async resumePlanning(row: any) {
    this.stoppingItem = row.id || null;
    try {
      const newSeq = this.seqPemulihan(row);

      if (row.id) {
        await RencanaAskepSvc.update(row.id, {
          pasien_rm: this.rm,
          register_id: parseInt(this.register),
          authored_at: row.authored_at,
          content: row.content,
          seq: newSeq,
          stopped_at: null
        });
      }

      // Reload data to ensure sync
      await this.loadRencanaData();
    } catch (error) {
      console.error("Error resuming rencana askep:", error);
    } finally {
      this.stoppingItem = null;
    }
  }

  seqPemulihan(row: any): number {
    const grup = kelompokkan(this.planningList).find(g =>
      g.baris.some(b => b.id === row.id)
    );
    const seqGrup = grup ? this.seqGrup(grup) : null;

    if (seqGrup !== null) return seqGrup;

    const activeItems = this.planning.filter(p => !p.stopped_at);

    return (
      (activeItems.length > 0
        ? Math.max(...activeItems.map(p => p.seq || 0))
        : 0) + 1
    );
  }

  // Verify planning item
  async verifyPlanning(row: any) {
    if (!row.id || this.verifikasiTerkunci) {
      return;
    }

    if (row.user && String(row.user.id) === String(userModule.user.id)) {
      const lanjut = confirm(
        "Perencanaan ini Anda tulis sendiri. Verifikasi tetap dilanjutkan?"
      );

      if (!lanjut) return;
    }

    this.verifyingItem = row.id;
    try {
      await RencanaAskepSvc.verify(row.id, userModule.scopedUnitId);

      // Update local data with verification info
      // row.verified_at = moment().format("YYYY-MM-DD HH:mm:ss");
      // row.verificator = {
      //   id: userModule.user.id,
      //   name: userModule.user.nama
      // };

      // Reload data to ensure sync
      await this.loadRencanaData();
    } catch (error) {
      console.error("Error verifying rencana askep:", error);
    } finally {
      this.verifyingItem = null;
    }
  }

  editImplementation(item, idx) {
    this.implementationInput = item;
    this.implementationIdx = idx;
    this.implementation = item.content.map(it => {
      const base = {
        ...it,
        hasilSuggestions: [],
        hasilLoading: false,
        hasilSearch: null,
        hasilSearchTimer: null
      };
      if (it.obat) {
        // normalize legacy single-object obat -> array, and key each entry
        const list = Array.isArray(it.obat) ? it.obat : [it.obat];
        base.obat = list.map(d => ({ ...d, _k: this.nextObatKey() }));
      }
      return base;
    });
    this.implemented_at = item.authored_at ? new Date(item.authored_at) : null;
    this.dialogImplementation = true;
  }

  async updateImplementation(idx) {
    const item = this.implementationItems[idx];

    const implementationData = {
      date: this.implemented_at
        ? moment(this.implemented_at).format("YYYY-MM-DD HH:mm:ss")
        : item.authored_at,
      implementation: [...this.implementation],
      unit: item.unit,
      user: item.user
    };

    // Update local data
    item.authored_at = implementationData.date;
    item.content = implementationData.implementation;

    // Update to backend
    if (item.id) {
      this.savingImplementation = true;

      try {
        // Clean up UI properties before sending to backend
        const cleanImplementation = implementationData.implementation.map(
          itm => ({
            ...itm,
            options: undefined,
            need_text: undefined,
            name: undefined,
            hasilLoading: undefined,
            hasilSearch: undefined,
            hasilSearchTimer: undefined,
            hasilSuggestions: undefined
          })
        );

        const resp = await ImplementasiAskepSvc.update(item.id, {
          pasien_rm: this.rm,
          register_id: parseInt(this.register),
          // unit_id: userModule.user.unit_id,
          // user_id: userModule.user.id,
          authored_at: implementationData.date,
          content: cleanImplementation
        });

        if (resp.status == 1) {
          this.dialogImplementation = false;
          // Reload data after update
          await this.loadImplementasiData();
        }
      } finally {
        this.savingImplementation = false;
      }
    }
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.implemented_at > dtime) {
      this.$nextTick(() => {
        this.implemented_at = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }
}
